import { PROFILER_INDUSTRY_CODES_SEARCH_FIELDS } from '../../../../../utils/constants/fields';
import Input from '../../../../../components/inputs/Input';
import CityZipAutocompleteInput from '../../../../../components/inputs/CityZipAutocompleteInput';
import MultiSelect from '../../../../../components/inputs/MultiSelect';
import RangeInput from '../../../../../components/inputs/RangeInput';
import OwnershipInfoButton from '../../../../../components/profiler/ownership/OwnershipInfoButton';
import { PROFILER_INDUSTRY_CODES_SEARCH_CATEGORIES } from '../../../../../utils/constants/searchCategories';
import {
  isProfilerAdvancedCriteriaDisabled,
  isProfilerAdvancedCriteriaSituationDisabled,
  isProfilerAdvancedCriteriaOwnershipDisabled
} from '../../../../../utils/constants/variables';

export const getProfilerIndustryCodesSearchFields = (state) => {
  const overlapingProps = {
    setFieldValue: state.setProfilerIndustryCodesFieldValue,
    showOnSubmitErrorState: state.onProfilerIndustryCodesSubmitErrorState,
    messages: state.profilerIndustryCodesValidationFields.messages,
    disabled: state.isProfilerIndustryCodesSearchFieldsDisabled
  };

  // The ownership chain position is required, and only enabled, with a structure.
  const hasOwnershipStructure = !!state.profilerIndustryCodesFields[
    PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_STRUCTURES.NAME
  ]?.length;

  return {
    [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.REVENUE_MIN.ID +
    PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.REVENUE_MAX.ID]: (
      <RangeInput
        fieldMin={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.REVENUE_MIN}
        fieldMax={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.REVENUE_MAX}
        valueMin={
          state.profilerIndustryCodesFields[PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.REVENUE_MIN.NAME]
        }
        valueMax={
          state.profilerIndustryCodesFields[PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.REVENUE_MAX.NAME]
        }
        {...overlapingProps}
        wrapClass={'col'}
      />
    ),
    [PROFILER_INDUSTRY_CODES_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA]: {
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MIN.ID +
      PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MAX.ID]:
        isProfilerAdvancedCriteriaDisabled ? null : (
          <RangeInput
            fieldMin={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MIN}
            fieldMax={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MAX}
            valueMin={
              state.profilerIndustryCodesFields[PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MIN.NAME]
            }
            valueMax={
              state.profilerIndustryCodesFields[PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MAX.NAME]
            }
            {...overlapingProps}
            wrapClass={'col'}
          />
        ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_PERIOD.ID]:
        isProfilerAdvancedCriteriaDisabled ? null : (
          <MultiSelect
            field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_PERIOD}
            value={
              state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_PERIOD.NAME
              ]
            }
            {...overlapingProps}
            withSingleClear
            inputWrap={{ enable: true, className: 'col' }}
            forceRequired={
              !!state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MIN.NAME
              ] ||
              !!state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MAX.NAME
              ]
            }
            disabled={
              state.isProfilerIndustryCodesSearchFieldsDisabled ||
              (!state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MIN.NAME
              ] &&
                !state.profilerIndustryCodesFields[
                  PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MAX.NAME
                ])
            }
          />
        ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EBIT_MARGIN_MIN.ID +
      PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EBIT_MARGIN_MAX.ID]:
        isProfilerAdvancedCriteriaDisabled || state.isProfilerLiteOnly ? null : (
          <RangeInput
            fieldMin={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EBIT_MARGIN_MIN}
            fieldMax={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EBIT_MARGIN_MAX}
            valueMin={
              state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EBIT_MARGIN_MIN.NAME
              ]
            }
            valueMax={
              state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EBIT_MARGIN_MAX.NAME
              ]
            }
            {...overlapingProps}
            wrapClass={'col'}
          />
        ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EMPLOYEES_MIN.ID +
      PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EMPLOYEES_MAX.ID]: (
        <RangeInput
          fieldMin={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EMPLOYEES_MIN}
          fieldMax={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EMPLOYEES_MAX}
          valueMin={
            state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EMPLOYEES_MIN.NAME
            ]
          }
          valueMax={
            state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EMPLOYEES_MAX.NAME
            ]
          }
          {...overlapingProps}
          wrapClass={'col'}
        />
      ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.SITUATION.ID]:
        isProfilerAdvancedCriteriaDisabled || isProfilerAdvancedCriteriaSituationDisabled ? null : (
          <MultiSelect
            field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.SITUATION}
            value={
              state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.SITUATION.NAME
              ]
            }
            {...overlapingProps}
            inputWrap={{ enable: true, className: 'col' }}
          />
        ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.LISTING_STATUS.ID]:
        isProfilerAdvancedCriteriaDisabled || isProfilerAdvancedCriteriaOwnershipDisabled ? null : (
          <MultiSelect
            field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.LISTING_STATUS}
            labelAddon={<OwnershipInfoButton />}
            value={
              state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.LISTING_STATUS.NAME
              ]
            }
            {...overlapingProps}
            inputWrap={{ enable: true, className: 'col' }}
          />
        ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_STRUCTURES.ID]:
        isProfilerAdvancedCriteriaDisabled || isProfilerAdvancedCriteriaOwnershipDisabled ? null : (
          <MultiSelect
            field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_STRUCTURES}
            value={
              state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_STRUCTURES.NAME
              ]
            }
            {...overlapingProps}
            inputWrap={{ enable: true, className: 'col' }}
          />
        ),
      // Like CAGR period: disabled until a structure is chosen, then required.
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_BASIS.ID]:
        isProfilerAdvancedCriteriaDisabled || isProfilerAdvancedCriteriaOwnershipDisabled ? null : (
          <MultiSelect
            field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_BASIS}
            value={
              state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_BASIS.NAME
              ]
            }
            {...overlapingProps}
            withSingleClear
            inputWrap={{ enable: true, className: 'col' }}
            forceRequired={hasOwnershipStructure}
            disabled={overlapingProps.disabled || !hasOwnershipStructure}
          />
        ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.HEADQUARTER.ID]: (
        <MultiSelect
          field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.HEADQUARTER}
          value={
            state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.HEADQUARTER.NAME
            ]
          }
          {...overlapingProps}
          withSingleClear
          inputWrap={{ enable: true, className: 'col' }}
        />
      ),
      // Third row: Geo location fields - Country, City/Zipcode, Distance
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CITY_ZIPCODE.ID]: (
        <CityZipAutocompleteInput
          field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CITY_ZIPCODE}
          value={
            state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CITY_ZIPCODE.NAME
            ]
          }
          setFieldValue={state.setProfilerIndustryCodesFieldValue}
          countries={
            state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.HEADQUARTER.NAME
            ]
          }
          messages={state.profilerIndustryCodesValidationFields.messages}
          showOnSubmitErrorState={state.onProfilerIndustryCodesSubmitErrorState}
          inputWrap={{ enable: true, className: 'col' }}
          disabled={
            state.isProfilerIndustryCodesSearchFieldsDisabled ||
            !(
              state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.HEADQUARTER.NAME
              ]?.length > 0
            )
          }
        />
      ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.DISTANCE.ID]: (
        <Input
          field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.DISTANCE}
          value={
            state.profilerIndustryCodesFields[PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.DISTANCE.NAME]
          }
          {...overlapingProps}
          inputWrap={{ enable: true, className: 'col' }}
          disabled={
            state.isProfilerIndustryCodesSearchFieldsDisabled ||
            !state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CITY_ZIPCODE.NAME
            ]?.trim()
          }
        />
      )
    }
  };
};
